import { render, staticRenderFns } from "./RecipeTable.vue?vue&type=template&id=26fd931a&"
import script from "./RecipeTable.vue?vue&type=script&lang=ts&"
export * from "./RecipeTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports